import { render, staticRenderFns } from "./WeightTracking.vue?vue&type=template&id=9b168b3a"
import script from "./WeightTracking.vue?vue&type=script&lang=js"
export * from "./WeightTracking.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports